"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Order_1 = require("../../classes/Order");
var Product_1 = require("../../classes/Product");
var Address_1 = require("../../classes/Address");
var Student_1 = require("../../classes/Student");
var Service_1 = require("../../classes/Service");
var Cashier_1 = require("../../classes/Cashier");
var Teller_1 = require("../../../DriveScout/Billing/Teller");
var BillingGateway_1 = require("../../classes/billing/BillingGateway");
var PaymentRequest_1 = require("../../common/payments/PaymentRequest");
var StudentOrdersCreateController = /** @class */ (function () {
    function StudentOrdersCreateController($scope, $state, $stateParams, UsersModel, FlashService, UserService, OrdersModel, ProductsModel, $q, CreateOrderService, Stripe3DSService) {
        var _this = this;
        /** The order form only builds the order; this screen sends it and sees the answer, so it holds the key. */
        this.newOrder = new PaymentRequest_1.PaymentRequest();
        this.$scope = $scope;
        var $order = new Order_1.Order();
        var $student = new Student_1.Student(UserService.getCurrentUser());
        $order.setStudent($student);
        CreateOrderService.cashier().setOrder($order);
        this.CreateOrderService = CreateOrderService;
        this.loading = false;
        this.$state = $state;
        this.student = UserService.getCurrentUser();
        this.FlashService = FlashService;
        this.OrdersModel = OrdersModel;
        this.UsersModel = UsersModel;
        this.Stripe3DSService = Stripe3DSService;
        this.product = null;
        this.products = [];
        this.addresses = [];
        this.$cashier = this.CreateOrderService.cashier();
        // Get gateway config for 3DS handling
        var policies = this.$cashier.policies();
        var billingPolicy = policies.getPolicyByName("billing");
        if (billingPolicy.metaExistsByKey("billing_gateway")) {
            this.gateway_config = (0, BillingGateway_1.createBillingGatewayFromPolicies)(policies).config();
        }
        else {
            this.gateway_config = {};
        }
        this.loading = false;
        this.submitting = false;
        this.createOrder = this.createOrder.bind(this);
        var getBillingAddresses = this.UsersModel.getPickupLocations(this.student.id);
        var getProducts = ProductsModel.get({
            paging: false,
            disabled: 0,
            purchasable: true,
        });
        var getPaymentMethods = this.UsersModel.getStudentPaymentMethods(this.student.id);
        $q.all([getBillingAddresses, getPaymentMethods, getProducts]).then(function (responses) {
            _this.addresses = responses[0].pickuplocations.map(function (location) {
                var address = Object.assign({}, location.address);
                return new Address_1.Address(location.id, location.name, address.street, address.city, address.state, address.zip, address.lat, address.lng);
            });
            _this.$cashier.setStudentAddresses(_this.addresses);
            var paymentMethods = responses[1].payment_methods;
            _this.$cashier.setStudentPaymentMethods(paymentMethods);
            _this.products = responses[2].products.data.map(function (product) {
                var $product = new Product_1.Product(product);
                var $services = product.sessiontypes.map(function (service) {
                    return new Service_1.Service(service);
                });
                $product.setServices($services);
                return $product;
            });
            _this.loading = false;
        });
    }
    StudentOrdersCreateController.prototype.reset = function () {
        var order = new Order_1.Order();
        var student = new Student_1.Student(this.student);
        order.setStudent(student);
        this.$cashier.$use_existing_payment_method = false;
        this.$cashier.setOrder(order);
        this.loading = false;
        this.submitting = false;
    };
    StudentOrdersCreateController.prototype.createOrder = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, threeDSResult, confirmResponse, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitting = true;
                        order.submitted = true;
                        if (this.$cashier.validateMinimumPayment() === false) {
                            this.FlashService.setMessage({
                                type: "warning",
                                message: "You must pay at least " +
                                    (0, Teller_1.inDollars)(this.$cashier.minimumDepositAmountRequired()),
                            });
                            order.submitted = false;
                            this.submitting = false;
                            return [2 /*return*/];
                        }
                        data = (0, Cashier_1.cashierOrderRequestTransformer)(this.$cashier);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.OrdersModel.create(this.newOrder.bodyFor((0, PaymentRequest_1.orderWithoutOneTimeTokens)(data), function (requestId) { return (__assign(__assign({}, data), { request_id: requestId })); }))];
                    case 2:
                        response = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.answered(response));
                        if (!this.Stripe3DSService.isThreeDSecureRequired(response)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Stripe3DSService.handle3DSChallenge(response.client_secret, this.gateway_config.stripe_publishable_key)];
                    case 3:
                        threeDSResult = _a.sent();
                        if (!threeDSResult.success) {
                            this.newOrder.settled(PaymentRequest_1.PaymentOutcome.challengeFailed(threeDSResult));
                            this.FlashService.setMessage({
                                type: "error",
                                message: threeDSResult.error ||
                                    "Payment authentication failed. Please try again.",
                            });
                            order.submitted = false;
                            this.reset();
                            this.$scope.$applyAsync();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Stripe3DSService.confirmOrderPayment(response.order_id, response.payment_intent_id, {
                                student_id: this.$cashier.order().student().id(),
                                amount: response.amount,
                            })];
                    case 4:
                        confirmResponse = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.answered(confirmResponse));
                        this.FlashService.setMessage({
                            type: "success",
                            message: confirmResponse.message,
                        });
                        this.reset();
                        this.$scope.$applyAsync(function () {
                            _this.$state.go("drivecoach.student.orders");
                        });
                        return [2 /*return*/, confirmResponse];
                    case 5:
                        // Standard success (no 3DS required)
                        this.FlashService.setMessage({
                            type: "success",
                            message: response.message,
                        });
                        this.reset();
                        this.$scope.$applyAsync(function () {
                            _this.$state.go("drivecoach.student.orders");
                        });
                        return [2 /*return*/, response];
                    case 6:
                        error_1 = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.failed(error_1));
                        order.submitted = false;
                        this.submitting = false;
                        this.$scope.$applyAsync();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    StudentOrdersCreateController.prototype.addProductToOrder = function () {
        this.$cashier.addProduct(this.product);
        this.product = null;
        if (this.$cashier.allowsPartialPayments() === false) {
            this.$cashier.order().payments()[0].setAmount(this.$cashier.totalDue());
        }
        this.$cashier.calculateTotal();
    };
    return StudentOrdersCreateController;
}());
StudentOrdersCreateController.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "UserService",
    "OrdersModel",
    "ProductsModel",
    "$q",
    "CreateOrderService",
    "Stripe3DSService",
];
exports.default = StudentOrdersCreateController;
